<template>
  <div>
  <HighBoard @clickDashboard="openPageTestDashboard" @clickWiki="openPageWiki" @openNotification="openNotification" @logOut="logOutClick" :username="'guest'"
    :role="'guest'" />
  <div class="main-dask" v-if="workPage == 'dash'">
    <div class="solo-company" v-for="company, companyName in sensorList" :key="companyName">
      <div class="widget-area">
        <p class="rows-name middle-high">Датчики</p>
        <div class="widget-row-place">
          <SensorWidget v-for="item in company.sensors" :key="item.id_sensor"
            :name="item.name"
            :mac="item.MAC"
            :temperature="item.temperature"
            :vibration="item.vibrations"
            :total_time="item.total_time"
            :month_time="item.month_time"
            :week_time="item.week_time"
            :day_time="item.day_time"
            :rpm="item.rpm"
            :power="item.power"
            :id="item.id_sensor"
            :message="message"
            :addition_params="item.addition_params"
            :isMotorLifeGone="(item.motor_life_offset+item.motor_life_start) > item.total_time"
            :sensor="true"
            :date_update_param="item.date_update_param"
            :isSensorImage="item.sensor_image"
            :isPlaceImage="item.place_image"
            @open-graf="openGraphWindow"
            :levelVibrationsCode="item.level_vibrations_code"
            @open-param="openParamWindow"
          />
        </div>

      </div>
      <div class="widget-area" v-if="company.counters.length != 0">
        <p class="rows-name middle-high">Счетчики</p>
        <div class="widget-row-place">
          <CounterWidget v-for="item in company.counters" :key="item.id_counter" :name="item.name"
            :address="item.address" :voltage="item.voltage" :frequency="item.frequency" :cosFi="item.cos_fi"
            :current="item.current" :energy="item.energy_total" :energyDay="item.energy_day" :id="item.id_counter"
            @open-graf="openGraphWindow" @open-param="openParamWindow" />
        </div>
      </div>
    </div>
    <Transition name="fade" mode="out-in">
      <WindowGraph
        v-if="switcherGraph"
        @closeWindow="closeGraphWindow"
        :name="graphWindow.name"
        :id="graphWindow.id"
        :listElements="graphWindow.listElements"
        :typeWindow="graphWindow.typeWindow"
      />
    </Transition>
    <Transition name="fade" mode="out-in">
      <WindowParam 
        v-if="switcherParam"
        :addition="true"
        @closeWindow="closeParamWindow"
        @child-event="handleChildMessage"
        :id="paramWindow.id"
        :mac="paramWindow.mac"
        :power="paramWindow.power"
        :rpm="paramWindow.rpm"
        :motor_life_offset="paramWindow.motor_life_offset"
        :motor_life_start="paramWindow.motor_life_start"
        :name_element="paramWindow.name"
        :date="paramWindow.date"
        :company_id="paramWindow.company"
        :addition_params="paramWindow.addition_params"
        :typeWindow="paramWindow.typeWindow"
        :groupSensor="paramWindow.groupSensor"
        :isNewGroup="paramWindow.isNewGroup"
        :showSensorImage="paramWindow.sensor_image"
        :showPlaceImage="paramWindow.place_image"
        :total_time="paramWindow.total_time"
        :userType="paramWindow.userType"
      />
    </Transition>
  </div>
  <Transition name="fade" mode="out-in">
    <Notifications v-if="windowShadow" @closeWindow="closeNotification" class="notifications-overlay" />
  </Transition>
</div>
<WikiVue v-if="workPage == 'wiki'" />
</template>

<script>
import { shallowRef } from 'vue'
import { mapGetters, mapActions } from 'vuex'

import SensorWidget from '@/pages/dashboard/SensorWidget.vue'
import CounterWidget from '@/pages/dashboard/CounterWidget.vue'
import WindowGraph from '@/pages/dashboard/WindowGraph.vue'
import WindowParam from '@/pages/dashboard/WindowParam.vue'
import WikiVue from '@/pages/wiki/WikiPage.vue'
import HighBoard from '@/components/HighBoard.vue'
import Notifications from '@/components/Notifications.vue'

export default {
  name: 'TestDashboard',
  computed: {
    ...mapGetters('user', {
      userOptions: 'getUserOptions',
    }),
    ...mapGetters('sensors', {
      sensorList: 'getSensorList',
    })
  },
  data() {
    return {
      workPage: 'dash',
      switcherGraph: false,
      switcherParam: false,
      message: null,
      windowShadow: false,
      paramWindow: {
      },
      graphWindow: {
      },
      flagStopTimeout: false,
      timeoutID: null
    }
  },
  methods: {
    ...mapActions('sensors', {
      getSensorLastData: 'getSensorLastData',
    }),
    openNotification() {
      this.windowShadow = true
    },
    closeNotification() {
      this.windowShadow = false
    },
    logOutClick() {
      localStorage.setItem('token', '');
      this.$router.push('/');
    },

    openPageWiki() {
      this.workPage = 'wiki'
    },

    openPageTestDashboard() {
      this.workPage = 'dash'
    },
    openGraphWindow(id, name, typeWindow) {
      this.switcherGraph = true
      let listElemForGraph = [];
      for (const [key, value] of Object.entries(this.sensorList)) {
        if (typeWindow == 'sensor' && null != value.sensors.find(el => el.id_sensor == id)) {
          listElemForGraph = value.sensors;
        }
        if (typeWindow == 'counter' && null != value.counters.find(el => el.id_counter == id)) {
          listElemForGraph = value.counters;
        }
      }
      this.graphWindow = {
        id: id,
        name: name,
        typeWindow: typeWindow,
        listElements: listElemForGraph
      }
    },
    closeGraphWindow() {
      this.switcherGraph = false
      this.graphWindow = {}
    },
    openParamWindow(id, name, typeWindow) {
      const groups = { 0: 'Без группы', 1: 'Группа 1', 2: 'Группа 2', 3: 'Группа 3' }

      if (typeWindow == 'sensor') {
        for (const property in this.sensorList) {
          this.sensorList[property].sensors.find(el => {
            if (el.id_sensor == id && el.name == name) {
              this.paramWindow.typeWindow = typeWindow
              this.paramWindow.id = el.id_sensor
              this.paramWindow.mac = el.MAC
              this.paramWindow.power = el.power
              this.paramWindow.rpm = el.rpm
              this.paramWindow.motor_life_offset = el.motor_life_offset
              this.paramWindow.motor_life_start = el.motor_life_start
              this.paramWindow.name = el.name
              this.paramWindow.date = el.created_date
              this.paramWindow.company = el.company_id ? el.company_id : 0
              this.paramWindow.addition_params = el.addition_params
              this.paramWindow.groupSensor = groups[el.group]
              this.paramWindow.isNewGroup = el.is_new
              this.paramWindow.place_image = el.place_image
              this.paramWindow.sensor_image = el.sensor_image
              this.paramWindow.total_time = el.total_time
              this.paramWindow.userType = 'demo'
            }
          })
        }
        this.switcherParam = true

      } else if (typeWindow == 'counter') {
        for (const property in this.sensorList) {
          this.sensorList[property].counters.find(el => {
            if (el.id_counter == id && el.name == name) {
              this.paramWindow.typeWindow = typeWindow
              this.paramWindow.id = el.id_counter
              this.paramWindow.mac = el.address
              this.paramWindow.name = el.name
              this.paramWindow.date = el.created_date
              this.paramWindow.company = el.company_id ? el.company_id : 0
              this.paramWindow.addition_params = []
            }
          })
        }

        this.switcherParam = true
        //console.log("switcherParam после открытия:", this.switcherParam)
      } else {
        alert("wrong property")
      }

    },
    closeParamWindow() {
      this.switcherParam = false

      //console.log(this.switcherParam)
      this.paramWindow = {}

    },
    handleChildMessage(msg) {
      this.message = msg
    },
    updateData() {
      try {
        this.getSensorLastData(true);
        if (!this.flagStopTimeout) {
          this.timeoutID = setTimeout(this.updateData, 10000)
        }
      } catch (error) {
        this.$router.push('/');
      }
    },
  },
  
  created() {
    this.flagStopTimeout = false
    this.getSensorLastData(true);
    this.timeoutID = setTimeout(this.updateData, 10000)
  },
  beforeUnmount() {
    this.flagStopTimeout = true
    clearTimeout(this.timeoutID)
  },
  components: {
    HighBoard,
    WikiVue,
    SensorWidget,
    CounterWidget,
    WindowGraph,
    WindowParam,
    Notifications,
  }
}
</script>

<style scoped lang="scss">
.notifications-overlay {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  z-index: 10;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
}
.solo-company {
  overflow: hidden;
  transition: all .2s ease;
  padding: 24px 30px;
}

.widget-row-place {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}

.rows-name {
  padding: 10px 20px;
  color: var(--gray-dark-color);
}

.widget-area {
  background: rgba(0, 0, 0, 0.02);
  border-radius: 3px;
  margin: 5px 0;
}

.param-place {
  display: flex;
  justify-content: space-between;
  padding: 0 19px;
  max-width: 560px;
}

.main-dask {
  height: 93vh;
  padding: 10px 1vw;
  overflow-y: auto;
}

@media screen and (max-width: 1210px) {
  .widget-row-place {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 810px) {
  .widget-row-place {
    grid-template-columns: repeat(1, 1fr);
  }
}

.first-line {
  display: flex;
  justify-content: space-between;
  padding: 3px 5px;
  max-width: 543px;
}
</style>
